// CourseCard.js
import React from "react";
import {
  Box,
  Flex,
  VStack,
  Text,
  Button,
  Image,
} from "@chakra-ui/react";
import DarkArrow from "./Images/Dark-Courses-Arrow-Icon.svg";

export function CourseCard({ title, description, papers, onClick }) {
  return (
    <Box
      w="100%"
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      p={{ base: "24px 16px", md: "35px 19px" }}
      gap="17px"
      borderRadius="14px"
      bg="#F7FBFD"
      boxShadow="0px 0px 8.6px rgba(0, 0, 0, 0.1)"
    >
      <Text
        color="#161616"
        fontSize={{ base: "16px", md: "24px" }}
        fontWeight="400"
        maxW={{ base: "200px", md: "100%" }}
        noOfLines={2}
      >
        {title}
      </Text>

      <Text color="#161616" fontSize="12px" fontWeight="400">
        {description}
      </Text>

      <VStack align="stretch" spacing="2px" w="100%">
        {papers.map((paper, idx) => (
          <Text
            key={idx}
            color="#161616"
            fontSize="12px"
            fontWeight="400"
            lineHeight="1.2"
          >
            <Text as="span" fontWeight = " 500 ">
              {paper.label}:
            </Text>
            {paper.percentage}
          </Text>
        ))}
      </VStack>

      <Button
        onClick={onClick}
        alignSelf="flex-end"
        p={{ base: "8px 24px", md: "10px 47px" }}
        borderRadius="8px"
        color="#161616"
        _hover={{ bg: "transparent" }}
      >
        <Flex align="center" gap="8px">
          <Text fontSize="14px" fontWeight="400">
            Access Course
          </Text>
          <Image src={DarkArrow} alt="arrow" boxSize="20px" />
        </Flex>
      </Button>
    </Box>
  );
}
